import React from "react";
import image1 from "../../assets/image1.png"; 
import image2 from "../../assets/image2.png"; 
import image3 from "../../assets/image3.png";
import "./SliderSection.css"; 
const SliderSection = () => {
  return (
    <section className="slider-section">
      <div className="slider">
        <div className="slide">
          <img src={image1} alt="Slide 1" />
        </div>
        <div className="slide">
          <img src={image2} alt="Slide 2" />
        </div>
        <div className="slide">
          <img src={image3} alt="Slide 3" />
        </div>
      </div>
    </section>
  );
};

export default SliderSection;
